import { render, staticRenderFns } from "./ViewReminder.vue?vue&type=template&id=06d11388&scoped=true&"
import script from "./ViewReminder.vue?vue&type=script&lang=js&"
export * from "./ViewReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d11388",
  null
  
)

export default component.exports